import { computed } from 'vue';
import { useRoute } from 'vue-router';

import { ROUTE_NAMES } from '@/router/route-names';
import { useStore } from '@/store';

const useSeoTextPage = () => {
  const store = useStore();
  const route = useRoute();

  const text = computed<string | undefined>(() => {
    const forbiddenPath = '/account';
    const isForbiddenPath = route.path.includes(forbiddenPath);
    const isForbiddenName = typeof route.name === 'string' ? [ROUTE_NAMES.TYP, ROUTE_NAMES.Checkout].includes(route.name) : false;

    if (isForbiddenPath || isForbiddenName) {
      return;
    }

    return store.getters['seo/getSeo']?.text;
  });

  return {
    text,
  };
};

export default useSeoTextPage;
